import {
  Button,
  ButtonColor,
  FontWeight,
  Grid, Image, Spacing, SpacingName,
  Typography,
} from '@doveit/lego';
import React from 'react';
import { useRouter } from 'next/router';
import { requireFromStaticAsset } from '../../utils/assetsUtils';
import Markdown from '../markdown/Markdown';

export interface BasicStripeProps extends React.AriaAttributes {
  title: string,
  subtitle?: string,
  content: string,
  image: {
    url: string,
    alt: string,
  },
  isAbsoluteImageUrl?: boolean,
  action?: {
    label: string,
    href: string,
  },
}

const BasicStripe: React.FC<BasicStripeProps> = ({
  title,
  subtitle,
  content,
  image,
  action,
  isAbsoluteImageUrl = false,
}) => {
  const router = useRouter();
  return (
    <Grid gutter={SpacingName.MEDIUM}>
      <Grid.Unit size={{ MD: 1 / 3 }}>
        <Image
          src={!isAbsoluteImageUrl ? requireFromStaticAsset(image.url) : image.url}
          alt={image.alt}
          width="100%"
          fit
          lazyLoad
          overflow
        />
      </Grid.Unit>
      <Grid.Unit size={{ MD: 2 / 3 }}>
        <Typography.H3 color="brand.primary" uppercase>
          {title}
        </Typography.H3>
        {subtitle && (
          <Spacing margin={[SpacingName.SMALLER, 0, 0]}>
            <Typography.H4>
              {subtitle}
            </Typography.H4>
          </Spacing>
        )}
        <Spacing margin={[SpacingName.SMALLER, 0, 0]}>
          <Typography.H4 tagName="div" fontWeight={FontWeight.LIGHT}>
            <Markdown>
              {content}
            </Markdown>
          </Typography.H4>
        </Spacing>
        {action && (
          <Spacing margin={[SpacingName.SMALL, 0, 0]}>
            <Button
              label={action.label}
              href={action.href}
              onClick={() => router.push(action.href)}
              color={ButtonColor.PRIMARY}
            />
          </Spacing>
        )}
      </Grid.Unit>
    </Grid>
  );
};

export default BasicStripe;
